import axios from "axios";
import { AppDispatch } from "../store";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { getApiUrl } from "../helpers/environmentHelper";
import { OrderStatus } from "../../models/responses/orderStatus";
import {
  setOrderStatus,
  setOrderStatusList,
  setOrderStatusListForMenu,
  setIsWaitingOrderStatusGetResponse,
  setIsWaitingOrderStatusPostResponse,
  setIsWaitingOrderStatusPutResponse,
} from "../slices/orderStatusSlice";
import { defaultOrderPageType } from "../../models/responses/orderPageType";
import { ClientType } from "../../models/enums/clientTypeEnum";
import { acquireApiToken } from "../helpers/apiTokenHelper";

export const getOrderStatusesForMenu =
  (instance: IPublicClientApplication, account: AccountInfo | null, clientType: ClientType) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingOrderStatusGetResponse(true));

      try {
        let menuData = localStorage.getItem(`menu-${clientType}`);
        if (menuData) {
          let menuObject = JSON.parse(menuData);
          dispatch(
            setOrderStatusListForMenu({ orderStatusListForMenu: menuObject })
          );
        }

        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: OrderStatus[] = (
                  await axios.get(`${baseUrl}/orderStatuses/menu?clientType=${clientType}`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                localStorage.setItem(`menu-${clientType}`, JSON.stringify(getData));
                dispatch(setIsWaitingOrderStatusGetResponse(false));
                dispatch(
                  setOrderStatusListForMenu({ orderStatusListForMenu: getData })
                );
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingOrderStatusGetResponse(false));
        console.log(error);
      }
    };

export const getOrderStatuses =
  (instance: IPublicClientApplication, account: AccountInfo | null, clientType: ClientType | null,) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingOrderStatusGetResponse(true));

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: OrderStatus[] = (
                  await axios.get(`${baseUrl}/orderStatuses?clientType=${clientType ?? ""}`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setIsWaitingOrderStatusGetResponse(false));
                dispatch(setOrderStatusList({ setOrderStatusList: getData }));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingOrderStatusGetResponse(false));
        console.log(error);
      }
    };

export const getOrderStatusById =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    id: string | undefined
  ) =>
    async (dispatch: AppDispatch) => {
      if (!id) return;
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingOrderStatusGetResponse(true));

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: OrderStatus = (
                  await axios.get(`${baseUrl}/orderStatuses/${id}`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setIsWaitingOrderStatusGetResponse(false));

                if (!getData.orderPageType)
                  getData.orderPageType = defaultOrderPageType;

                dispatch(setOrderStatus({ orderStatus: getData }));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingOrderStatusGetResponse(false));
        console.log(error);
      }
    };

export const postOrderStatus =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    orderStatus: OrderStatus,
    onSuccess: (orderStatusId: string | null) => void
  ) =>
    async (dispatch: AppDispatch) => {
      dispatch(setIsWaitingOrderStatusPostResponse(true));
      const baseUrl = getApiUrl(window.location.hostname, 2);
      let responseId: string | null = null;
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              try {
                if (response) {
                  const responseData = await axios.post(
                    `${baseUrl}/orderStatuses`,
                    orderStatus,
                    {
                      timeout: 10000,
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response.accessToken}`,
                      },
                    }
                  );

                  if (responseData.status === 201) {
                    let locationArray =
                      responseData.headers["location"].split("/");
                    responseId = locationArray[locationArray.length - 1];
                  }
                }
              } finally {
                onSuccess(responseId);
                dispatch(setIsWaitingOrderStatusPostResponse(false));
              }
            });
        }
      } catch (error) {
        console.log(error);
        dispatch(setIsWaitingOrderStatusPostResponse(false));
      }
    };

export const putOrderStatus =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    orderStatus: OrderStatus,
    onSuccess: (orderStatusId: string | null) => void
  ) =>
    async (dispatch: AppDispatch) => {
      dispatch(setIsWaitingOrderStatusPutResponse(true));
      const baseUrl = getApiUrl(window.location.hostname, 2);
      let responseId: string | null = null;
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              try {
                if (response) {
                  const responseData = await axios.put(
                    `${baseUrl}/orderStatuses`,
                    orderStatus,
                    {
                      timeout: 10000,
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response.accessToken}`,
                      },
                    }
                  );
                  if (responseData.status === 204) {
                    onSuccess(orderStatus.id);
                  }
                }
              } finally {
                onSuccess(responseId);
                dispatch(setIsWaitingOrderStatusPutResponse(false));
              }
            });
        }
      } catch (error) {
        console.log(error);
        dispatch(setIsWaitingOrderStatusPutResponse(false));
      }
    };